export default {"src":"/_next/static/media/google-play.d39407e0.svg","height":40,"width":201,"blurWidth":0,"blurHeight":0};